import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { reducer as userReducer, NAME as user } from './user';
import {
  reducer as campaignsReducer,
  REDUCER_KEY as campaigns,
} from './campaigns';
import {
  reducer as advertisersReducer,
  REDUCER_KEY as advertisers,
} from './clients';
import { reducer as settingsReducer, NAME as settings } from './settings';
import { reducer as constsReducer, NAME as consts } from './consts';
import { reducer as chatsReducer, REDUCER_KEY as chats } from './chats';
import {
  reducer as proposalsReducer,
  REDUCER_KEY as proposals,
} from './proposals';
import {
  reducer as productsReducer,
  REDUCER_KEY as products,
} from './products';
//import { reducer as usersReducer, REDUCER_KEY as users } from './users';
import { reducer as adSlotReducer, REDUCER_KEY as adSlot } from './adslots';
import {
  reducer as adFormatReducer,
  REDUCER_KEY as adFormat,
} from './adformats';
import {
  reducer as notificationReducer,
  REDUCER_KEY as notifications,
} from './notifications';
import { reducer as basketsReducer, REDUCER_KEY as baskets } from './baskets';
import { reducer as flightsReducer, REDUCER_KEY as flights } from './flights';
import {
  reducer as productExtraFeesReducer,
  REDUCER_KEY as productExtraFees,
} from './productExtraFees';
import {
  reducer as adTypeExtraFeesReducer,
  REDUCER_KEY as adTypeExtraFees,
} from './adTypeExtraFees';
import {
  reducer as committedBasketsReducer,
  REDUCER_KEY as committedBaskets,
} from './baskets/committed';
import {
  reducer as committedFlightsReducer,
  REDUCER_KEY as committedFlights,
} from './flights/committed';
import {
  reducer as committedProposalsReducer,
  REDUCER_KEY as committedProposals,
} from './proposals/committed';
import { reducer as ordersReducer, REDUCER_KEY as orders } from './orders';
import {
  reducer as committedOrdersReducer,
  REDUCER_KEY as committedOrders,
} from './orders/committed';
import {
  reducer as settlementsReducer,
  REDUCER_KEY as settlements,
} from './settlements';
import {
  reducer as clientManagersReducer,
  REDUCER_KEY as clientManagers,
} from './clientManagers';
import {
  reducer as counterOfferProposalReducer,
  REDUCER_KEY as counterOfferProposal,
} from './proposals/counterOffer';
import {
  reducer as counterOfferFlightsReducer,
  REDUCER_KEY as counterOfferFlights,
} from './flights/counterOffer';
import {
  reducer as attachmentsReducer,
  REDUCER_KEY as attachments,
} from './attachments';

const rootReducer = combineReducers({
  [consts]: constsReducer,
  [user]: persistReducer({ key: [user], storage }, userReducer),
  //[users]: usersReducer,
  [advertisers]: advertisersReducer,
  [attachments]: attachmentsReducer,
  [campaigns]: campaignsReducer,
  [settings]: settingsReducer,
  [proposals]: proposalsReducer,
  [products]: productsReducer,
  [adSlot]: adSlotReducer,
  [adFormat]: adFormatReducer,
  [notifications]: notificationReducer,
  [chats]: chatsReducer,
  [baskets]: basketsReducer,
  [orders]: ordersReducer,
  [flights]: flightsReducer,
  [productExtraFees]: productExtraFeesReducer,
  [adTypeExtraFees]: adTypeExtraFeesReducer,
  [committedBaskets]: committedBasketsReducer,
  [committedFlights]: committedFlightsReducer,
  [committedProposals]: committedProposalsReducer,
  [settlements]: settlementsReducer,
  [committedOrders]: committedOrdersReducer,
  [clientManagers]: clientManagersReducer,
  [counterOfferProposal]: counterOfferProposalReducer,
  [counterOfferFlights]: counterOfferFlightsReducer,
});
export default rootReducer;
